/* eslint-disable import/extensions */
/* eslint-disable arrow-body-style */

// To make datePicker work on IE
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import VueAnalytics from 'vue-analytics';

import './filters';
import getTextPlugin from 'vue-gettext';
import VueTheMask from 'vue-the-mask';

import {
  setInteractionMode,
} from 'vee-validate';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import translations from './translations/translations.json';

import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/js/all.js';

import './gtm.js';

Vue.config.productionTip = false;

// Analytics
Vue.use(VueAnalytics, {
  id: 'UA-6118837-1',
  router,
});

// Translations
Vue.use(getTextPlugin, {
  translations,
  defaultLanguage: 'nl_BE',
});

// Mask
Vue.use(VueTheMask);

Vue.filter('translate', value => {
  return !value ?
    '' :
    Vue.prototype.$gettext(value.toString());
});

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    const p = el;
    p.clickOutsideEvent = function (event) {
      if (!(p === event.target || p.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', p.clickOutsideEvent);
  },
  unbind: function (p) {
    document.body.removeEventListener('click', p.clickOutsideEvent);
  },
});

// Interaction mode (when validation applies)
setInteractionMode('custom', context => {
  if (context.value === 'yes') {
    return {
      on: ['input'],
    };
  }

  return {
    on: ['change'],
  };
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
